// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Table_pagination__3KmN2","page-item":"Table_page-item__mFNxs","active":"Table_active__ZJ8gl","page-link":"Table_page-link__3Qv_g","disabled":"Table_disabled__36xD7"};